import hasNoValue from "../helpers/hasNoValue";

export const FILTERS = {
  "equal to": function (a, b) {
    return a === b;
  },
  "not equal to": function (a, b) {
    return a !== b;
  },
  "less than": function (a, b) {
    return a < b;
  },
  "greater than": function (a, b) {
    return a > b;
  },
  "less than or equal to": function (a, b) {
    return a <= b;
  },
  "greater than or equal to": function (a, b) {
    return a >= b;
  },
  contains: function (a, b) {
    return a.includes(b);
  },
  "does not contain": function (a, b) {
    return !a.includes(b);
  },
  "starts with": function (a, b) {
    return a.startsWith(b);
  },
  "ends with": function (a, b) {
    return a.endsWith(b);
  },
  "is empty": function (a, b) {
    return hasNoValue(a);
  },
  "is not empty": function (a, b) {
    return !hasNoValue(a);
  },
};
